module.exports = __webpack_public_path__ + "img/FZLC_2.4d8bad04.jpg";